import { render, staticRenderFns } from "./MenuPage.vue?vue&type=template&id=3773c5f6&scoped=true&"
import script from "./MenuPage.vue?vue&type=script&lang=js&"
export * from "./MenuPage.vue?vue&type=script&lang=js&"
import style0 from "./MenuPage.vue?vue&type=style&index=0&id=3773c5f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3773c5f6",
  null
  
)

export default component.exports